export default __webpack_public_path__ + "static/media/circle-three.3c4a404f.svg";